<template lang="pug">
k-page.page-not-found
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  w-go-down
  k-main( title='Page Not Found' )
    .message Very sorry! We couldn't find that page.
    w-btn( v-if='q' @click.prevent='retry' )
      | Try Again
    //- TODO: search
</template>

<script lang="js">
import KPage from '@/blocks/k-page'
import KMain from '@/blocks/k-main'
import DMainImage from '@/displays/d-main-image'
import WBtn from '@/widgets/w-btn'
import WGoDown from '@/widgets/w-go-down'
import { User, Page } from '@/mixins'

export default {
  name: 'NotFoundPage',
  mixins: [ User, Page ],
  components: { KPage, KMain, DMainImage, WBtn, WGoDown },
  props: {
    q: String
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    retry() {
      this.$router.replace( this.q )
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.page-not-found {
  display: flex;
  flex-direction: column;
  justify-content: center;
  main {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h1.title {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>
